import { createSelector } from 'reselect';
import { AppConfig } from '../../../app/app.config';
import {
    handleLoadNextPageAction, handleRehydrateAction,
    handleRemoveAction,
    handleSetFilterAction,
    handleSetTotalAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { PaginatableObjectFilters } from '../../store/bootstrap';
import * as jobActions from '../job/job.actions';
import * as fromTaskActions from './task.actions';
import { Task } from './task.model';

export interface ITaskFilters extends PaginatableObjectFilters {
    done?: boolean;
    sortBy?: string;
    sortDirection?: number;
    taskType?: string;
}

export interface State {
    ids: Array<string>;
    entities: { [id: string]: Task };
    total: number;
    filters: ITaskFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    total: 0,
    filters: {
        searchTerm: '',
        done: false,
        sortBy: 'dueDate',
        sortDirection: 0,
        limit: AppConfig.JOB_LIST_PAGE.limit,
        offset: 0,
        taskType: ''
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(
    state = initialState,
    action: fromTaskActions.Actions | jobActions.Actions
): State {
    switch (action.type) {
        case fromTaskActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromTaskActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromTaskActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromTaskActions.SET_FILTER: {
            return handleSetFilterAction(state, action);
        }
        case fromTaskActions.SET_TOTAL: {
            return handleSetTotalAction(state, action);
        }
        case fromTaskActions.LOAD_NEXT_PAGE: {
            return handleLoadNextPageAction(state, action);
        }
        case jobActions.WIPE: {
            return {
                ...state,
                ids: [],
                entities: {}
            };
        }
        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.reducer.ts